import { createNamespacedHelpers } from 'vuex';
import { prefixTypeFactory } from '../../../utils/StoreHelper';

export const NAMESPACE = 'configurator/misc';

export const { mapState, mapGetters, mapActions, mapMutations } =
  createNamespacedHelpers(NAMESPACE);

/**
 * @type {function(string): string}
 */
export const prefixType = prefixTypeFactory(NAMESPACE);

/**
 * @enum
 * @readonly
 */
export const MiscMutation = Object.freeze({
  SET_STATE: 'setState',
});

export default {
  namespaced: true,
  state() {
    return {
      createCustomOrderUrl: null,
      cartUrl: null,
      debugPrintingArea: false,
      debugTexture: false,
      editOrderItemUrl: undefined,
      fileUploadDescription: null,
      blankConfiguratorUrl: null,
    };
  },
  mutations: {
    /**
     *
     * @param {ConfiguratorMiscState} state
     * @param {string} createCustomOrderUrl
     * @param {string} cartUrl
     * @param {boolean} debugTexture
     * @param {boolean} debugPrintingArea
     * @param {string} editOrderItemUrl
     * @param {string} fileUploadDescription
     * @param {string} blankConfiguratorUrl
     */
    [MiscMutation.SET_STATE](
      state,
      {
        createCustomOrderUrl,
        cartUrl,
        debugTexture,
        debugPrintingArea,
        editOrderItemUrl,
        fileUploadDescription,
        blankConfiguratorUrl,
      }
    ) {
      if (createCustomOrderUrl) {
        state.createCustomOrderUrl = createCustomOrderUrl;
      }

      if (cartUrl) {
        state.cartUrl = cartUrl;
      }

      if (debugTexture) {
        state.debugTexture = !!debugTexture;
      }

      if (debugPrintingArea) {
        state.debugPrintingArea = !!debugPrintingArea;
      }

      if (editOrderItemUrl) {
        state.editOrderItemUrl = editOrderItemUrl;
      }

      if (fileUploadDescription) {
        state.fileUploadDescription = fileUploadDescription;
      }

      if (blankConfiguratorUrl) {
        state.blankConfiguratorUrl = blankConfiguratorUrl;
      }
    },
  },
};
